import React from "react";
import { Button, withStyles } from "@material-ui/core";

const StatusButton = withStyles((theme) => ({
  root: {
    padding: "4px 20px",
    height: "28px",
    borderRadius: "14px",
    fontWeight: "700",
    color: "#ffffff",
    backgroundColor: (props) => {
      switch (props.type) {
        case "on":
          return "#34E466";
        case "error":
          return "#FF4242";
        case "warning":
          return "#FFCA42";
        case "off":
          return "#D3D3D3";
        default:
          return "#7E7E7E";
      }
    },
    boxShadow: (props) => {
      switch (props.type) {
        case "on":
          return "0px 0px 6px rgba(69, 255, 65, 0.76)";
        case "error":
          return "0px 0px 6px rgba(255, 66, 66, 0.76)";
        case "warning":
          return "0px 0px 6px rgba(252, 185, 15, 0.76)";
        case "off":
          return "0px 0px 6px rgba(126, 126, 126, 0.76)";
        default:
          return "0px 0px 6px rgba(126, 126, 126, 0.76)";
      }
    },
    "&:hover": {
      backgroundColor: (props) => {
        switch (props.type) {
          case "on":
            return "#34E466";
          case "error":
            return "#FF4242";
          case "warning":
            return "#FFCA42";
          case "off":
            return "#D3D3D3";
          default:
            return "#7E7E7E";
        }
      },
    },
  },
}))(({ classes, children, ...other }) => {
  return (
    <Button classes={{ root: classes.root }} {...other}>
      {children}
    </Button>
  );
});

export default StatusButton;
